import React from 'react';
import { ErrorMappings } from '../../shared/_constants/errorMappings.constants';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';
/**
 * Common Error Page screen : Handles Page not found errors
 * @usage :  <ErrorPage/>
 */
export default function ErrorPage() {
  return (
    <>
      <ErrorMessage code={ErrorMappings[3].code} />
    </>
  );
}
